import parse from 'date-fns/parse';
import { action, computed, makeObservable } from 'mobx';
import { DATE_FORMAT } from 'src/common/constants';
import { formatDate } from 'src/common/utils/dateHelpers';
import FieldState from '../../common/store/FieldState';

/**
 * Parses an array of strings to ensure compatibility with
 * the DatesFilter component.
 */
export const stringsToDates = (stringDates: string[] = []): Date[] => {
  const dates: Date[] = [null];
  stringDates.forEach((date, index) => {
    if (date && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(date)) {
      dates[index] = parse(date, DATE_FORMAT, new Date());
    }
  });
  return dates;
};

/**
 * Formats all the dates as date strings.
 */
export const datesToString = (dates: Date[]): string[] => dates.reduce<string[]>(
  (stringDates, maybeDate) => {
    if (maybeDate != null) {
      stringDates.push(formatDate(maybeDate, DATE_FORMAT));
    }
    return stringDates;
  },
  [],
);

/**
 * Store the dates for the DatesFilter component.
 */
class DatesFieldState extends FieldState<Date[]> {
  constructor(dates: string[]) {
    super(stringsToDates(dates));
    makeObservable(this, {
      query: computed,
      reset: action,
    });
  }

  /**
   * Resets the value using the string interface.
   */
  public reset = (dates: string[]): void => {
    this.onChange(stringsToDates(dates));
  };

  /**
   * Converts all the date values to strings to be used in creating the
   * query string params.
   */
  public get query(): string[] {
    return datesToString(this.value);
  }
}

export default DatesFieldState;
